import { render, staticRenderFns } from "./add-letter.vue?vue&type=template&id=38500ff7&scoped=true"
import script from "./add-letter.vue?vue&type=script&lang=js"
export * from "./add-letter.vue?vue&type=script&lang=js"
import style0 from "./add-letter.vue?vue&type=style&index=0&id=38500ff7&prod&lang=css"
import style1 from "./add-letter.vue?vue&type=style&index=1&id=38500ff7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38500ff7",
  null
  
)

export default component.exports